









import { Component, Prop, Vue } from 'vue-property-decorator';

import { throttle } from '@/utils/decorators';

@Component
export default class Progress extends Vue {
  @Prop({ default: () => ({}) }) private mods!: Hash;
  @Prop({ default: () => 0 }) private cacheProgress!: number;
  @Prop({ default: () => 0 }) private playProgress!: number;

  private blockName: string = 'progress';
  private width: number = 0;
  private allowChangesOnMouseMove: boolean = false;

  private mounted() {
    this.width = this.$el.offsetWidth;
    this.mouseMove = this.mouseMove.bind(this);
    this.stopChanges = this.stopChanges.bind(this);
  }

  private click(event: any) {
    this.updateValue(event.offsetX / this.width);
  }

  private startChanges(event: any) {
    window.addEventListener('mousemove', this.mouseMove, { passive: true });
    window.addEventListener('mouseup', this.stopChanges, { passive: true });
  }

  private mouseMove(event: any) {
    this.updateValue((event.x - this.$el.getBoundingClientRect().left) / this.width);
  }

  private stopChanges() {
    window.removeEventListener('mousemove', this.mouseMove);
  }

  @throttle(32)
  private updateValue(value: number) {
    if (value < 0) value = 0;
    this.$emit('changed', value);
  }
}
